import * as Yup from 'yup';

export const SendInboundsFormValidationSchema = Yup.object().shape({
  CompanyID: Yup.object().test(
    'is-empty',
    'Company not selected',
    value => value && value.value
  ),
  Message: Yup.string()
    .min(10, 'String is too short. Minimum length is 10 characters.')
    .max(5000, 'You have exceeded the maximum number of 5000 characters')
    .required('This field is required'),
});
